import React, { useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Chip,
  InputAdornment,
  Snackbar,
  Alert,
   Select,        
  MenuItem,      
  FormControl,   
  InputLabel,
} from "@mui/material";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SaveIcon from "@mui/icons-material/Save";
import { useDispatch } from "react-redux";
import { setEditStep } from "../../../Redux/TestAuthoring/TestAuthoring";
import { CustomInput } from "../../../components-new/common";
import ElementDetails from "./ElementDetails";

const TestDataConfig = ({ item }) => {
  const dispatch = useDispatch();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleChange = (value, field) => {
    dispatch(setEditStep({ ...item, [field]: value }));
  };

  const handleDialogResponse = (confirm) => {
    handleChange(confirm, "updateRecordData");
    setDialogOpen(false);
    if (confirm) setSnackbarOpen(true);
  };

  return (
    <Box pr={3}>
      <Box display="flex" columnGap={3} mb={2}>
        <Box flex={1} position="relative">
          <CustomInput
            labelinput={"Test Data"}
            placeholder={"Enter Test Data"}
            value={item.TestData}
            onChange={(e) => handleChange(e.target.value, "TestData")}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setDialogOpen(true)}
                  size="small"
                  title="View Recorded Data"
                  sx={{
                    color: "primary.main",
                    p: "4px",
                    "&:hover": { backgroundColor: "rgba(26,115,232,0.08)" },
                  }}
                >
                  <CompareArrowsIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            }
          />
        </Box>

      <CustomInput
  labelinput={"Variable"}
  placeholder={"Enter Variable"}
  value={item.VarName}
  onChange={(e) => handleChange(e.target.value, "VarName")}
  flex={1}
  isDisabled={item.Step_Number === 0}
  endAdornment={
    <InputAdornment position="end">
      <Select
        variant="standard"
        disableUnderline
        value={item.varType || "default"}
        onChange={(e) => handleChange(e.target.value, "varType")}
        disabled={item.Step_Number === 0}
        sx={{
          fontSize: "12px",
          color: "primary.main",
          fontWeight: 600,
          minWidth: 120,
          "& .MuiSelect-select": { pr: "24px !important" },
        }}
      >
        <MenuItem value="default">Default</MenuItem>
        <MenuItem value="generated value">Generated Value</MenuItem>
        <MenuItem value="composite value">Composite Value</MenuItem>
      </Select>
    </InputAdornment>
  }
/>
      </Box>

      <ElementDetails item={item} />

      <Dialog
        open={dialogOpen}
        onClose={() => handleDialogResponse(false)}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            minWidth: 420,
            boxShadow: "0 8px 40px rgba(0,0,0,0.16)",
            overflow: "hidden",
          },
        }}
      >
        <Box
          sx={{
            background: "linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)",
            px: 3,
            py: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box display="flex" alignItems="center" gap={1}>
            <CompareArrowsIcon sx={{ color: "#fff", fontSize: 20 }} />
            <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "1rem" }}>
              Recorded Data Comparison
            </Typography>
          </Box>
          <IconButton
            size="small"
            onClick={() => handleDialogResponse(false)}
            sx={{ color: "rgba(255,255,255,0.8)", "&:hover": { color: "#fff" } }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <DialogContent sx={{ pt: 3, pb: 1, px: 3 }}>
          <Box
            sx={{
              backgroundColor: "#f5f7fa",
              borderRadius: "10px",
              px: 2,
              py: 1.5,
              mb: 2.5,
              display: "flex",
              alignItems: "center",
              gap: 1.5,
            }}
          >
            <Typography
              variant="body2"
              sx={{ color: "#555", fontWeight: 500, whiteSpace: "nowrap" }}
            >
              Recorded Data:
            </Typography>
            <Chip
              label={item.RecordedData ?? "null"}
              size="small"
              sx={{
                backgroundColor: item.RecordedData ? "#e3f2fd" : "#fce4ec",
                color: item.RecordedData ? "#1565c0" : "#c62828",
                fontWeight: 600,
                fontSize: "0.8rem",
                borderRadius: "6px",
              }}
            />
          </Box>

          <Box display="flex" alignItems="flex-start" gap={1}>
            <InfoOutlinedIcon sx={{ fontSize: 18, color: "#888", mt: "1px", flexShrink: 0 }} />
            <Typography variant="body2" sx={{ color: "#555", lineHeight: 1.6 }}>
              The recorded data shown above was captured during the original test recording. Would
              you like to overwrite it with the current Test Data value?
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 3, pt: 2, gap: 1 }}>
          <Button
            onClick={() => handleDialogResponse(false)}
            variant="outlined"
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              borderColor: "#ccc",
              color: "#555",
              px: 2.5,
              "&:hover": { borderColor: "#999", backgroundColor: "#f5f5f5" },
            }}
          >
            Keep Existing
          </Button>
          <Button
            onClick={() => handleDialogResponse(true)}
            variant="contained"
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              px: 2.5,
              background: "linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)",
              boxShadow: "none",
              "&:hover": { boxShadow: "0 4px 12px rgba(26,115,232,0.4)" },
            }}
          >
            Yes, Overwrite
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={8000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{ zIndex: 9999, top: "72px !important" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity="info"
          icon={<SaveIcon fontSize="small" />}
          sx={{
            borderRadius: "10px",
            fontWeight: 500,
            fontSize: "0.9rem",
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            alignItems: "center",
          }}
        >
          Click <strong>Save Changes</strong> to apply the update.
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default TestDataConfig;
